import { Route, Routes, BrowserRouter as Router, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';
import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css';
import "lineicons/dist/lineicons.css";
import 'boxicons/css/boxicons.min.css';
import 'simplebar-react/dist/simplebar.min.css';
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import "datatables.net-buttons";
import "datatables.net-buttons-bs5";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import "quill/dist/quill.snow.css";
import './App.css';
import Home from './pages/Home';
import UserManagement from './pages/UserManagement';
import UserManagementDetail from './pages/UserManagementDetail';
import ReportedProfiles from './pages/ReportedProfiles';
import PaymentHistory from './pages/PaymentHistory';
import SupportTicket from './pages/SupportTicket';
import StaticContent from './pages/StaticContent';
import Notifications from './pages/Notifications';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import AuthCoverSignin from './pages/auth/AuthCoverSignin';
import AuthLayout from './AuthLayout';
import MainLayout from './MainLayout';
import AuthCoverForgotPassword from './pages/auth/AuthCoverForgotPassword';
import AuthCoverSignup from './pages/auth/AuthCoverSignup';
import AuthCoverResetPassword from './pages/auth/AuthCoverResetPassword';
import "nprogress/nprogress.css";
import { useEffect } from 'react';
import nProgress from 'nprogress';


function App() {
  const location = useLocation();

  useEffect(() => {
    nProgress.start();

    const timer = setTimeout(() => {
      nProgress.done();
    }, 300);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path='/auth-cover-signin' element={<AuthCoverSignin />} />
          <Route path='/auth-cover-forgot-password' element={<AuthCoverForgotPassword />} />
          <Route path='/auth-cover-signup' element={<AuthCoverSignup />} />
          <Route path='/auth-cover-reset-password' element={<AuthCoverResetPassword />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path='/user-management' element={<UserManagement />} />
          <Route path='/user-management-detail' element={<UserManagementDetail />} />
          <Route path='/reported-profiles' element={<ReportedProfiles />} />
          <Route path='/payment-history' element={<PaymentHistory />} />
          <Route path='/support-ticket' element={<SupportTicket />} />
          <Route path='/static-content' element={<StaticContent />} />
          <Route path='/notifications' element={<Notifications />} />
          <Route path='/settings' element={<Settings />} />
          <Route path='/profile' element={<Profile />} />
        </Route>
      </Routes>
    </>
  );
}

const WrappedApp = () => (
  <Router>
    <App />
  </Router>
);

export default WrappedApp;
